import React from "react";
import {Fade} from "react-reveal";
import "./Greeting.scss";
import SocialMedia from "../../components/socialMedia/SocialMedia";
import Button from "../../components/button/Button";
import {greeting} from "../../portfolio";

export default function Greeting() {
  if (!greeting.displayGreeting) return null;

  return (
    <Fade bottom duration={900} distance="30px">
      <section className="greet-main" id="greeting">
        <div className="greeting-main">
          <div className="greeting-text-div">
            <p className="hero-eyebrow">SOFTWARE ENGINEER · BACKEND / FULL STACK</p>

            <h1 className="greeting-text">
              Syafiqah
              <br />
              <span>Hisham</span>
            </h1>

            <p className="greeting-text-p">
              {greeting.subTitle}
            </p>

            <div className="hero-meta">
              <span>JAVA</span>
              <span>SPRING BOOT</span>
              <span>REST API</span>
              <span>MICROSERVICES</span>
            </div>

            <div className="button-greeting-div">
              <Button text="View my work" href="#projects" />
              {greeting.resumeLink && greeting.resumeLink !== "YOUR_RESUME_LINK" && (
                <Button text="Resume" newTab={true} href={greeting.resumeLink} />
              )}
            </div>

            <SocialMedia />
          </div>

          <div className="greeting-image-div">
            <div className="hero-art-frame">
              <img
                alt="Software engineer working at a desk"
                src={require("../../assets/images/syafiqah-editorial.png")}
              />
            </div>
          </div>
        </div>
      </section>
    </Fade>
  );
}
